<template>
  <div class="row">
    <div class="col-lg-3">
    </div>
    <div class="col-lg-6">
      <div class="card mt-3 bg-white">
        <div class="card-body color-grey-primary">
          <sweetalert-icon
            icon="loading"
            v-if="load"
          />

          <div
            class="mt-3"
            v-for="(field,index) in field_mapping"
            :key="field.id"
          >
            <label>
              {{field.parameters.name}}
            </label>
            <input
              type="text"
              :id='"field"+index'
              v-model="field.parameters.value_field"
              :class="{
                'form-control': true
              }"
            />
          </div>
          <button
            type="
              button"
            @click="save()"
            class="btn btn-primary full mt-3"
          > Salvar </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["selective_process_uid"],
  data: () => ({
    load: false,
    field_mapping: [],
  }),
  mounted() {
    this.loadFields();
  },
  methods: {
    save() {
      console.log(this.$refs);
      let error = 0;
      for (let i in this.field_mapping) {
        if (this.field_mapping[i].parameters.required == true) {
          if (
            !this.validRequired(this.field_mapping[i].parameters.value_field)
          ) {
            error = error + 1;
            document.querySelector("#field" + i).classList.remove("is-valid");
            document.querySelector("#field" + i).classList.add("is-invalid");
          } else {
            document.querySelector("#field" + i).classList.add("is-valid");
            document.querySelector("#field" + i).classList.remove("is-invalid");
          }
        }
      }

      if (error > 0) {
        this.$toast.error("Preencha corretamente o formulário");
        return;
      }
      axios
        .put("/candidates", {
          candidates: { field_mapping: this.field_mapping },
        })
        .then((response) => {
          eventBus.$emit("RegisterFinished", { status: true });
          return;
        });
    },
    validRequired(value) {
      if (value != "" && value != false && value != null) {
        return true;
      }
      return false;
    },

    loadFields() {
      this.load = true;
      axios
        .get(
          "/candidates/field_mapping/selective_processes/" +
            this.selective_process_uid
        )
        .then((response) => {
          this.field_mapping = response.data;

          this.load = false;
        });
    },
  },
};
</script>
